import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Empty } from 'antd';
import { useSelector } from 'react-redux';
import './style.scss';
import useBluetooth from '../../hooks/useBluetooth'
import { useCollapse, useScanner } from '../../hooks';
import { vegetableDetect } from '../../utils';
import { notification } from 'antd';
import { checkCamera } from '../../utils/cameraCheck';
import notCamera from '../../assets/licensePlate/not-camera.png'
import { InfoCircleFilled } from '@ant-design/icons';
import notScan from '../../assets/licensePlate/not-scan.png'

const Fruits = () => {
    const timer = useRef(null);
    const bluetooth = useSelector(state => state.speaker.bluetooth);
    const { sendMessage, setupNotifications, stopNotifications } = useBluetooth();
    const [maxNum, setMaxNum] = useState(5); // 最大结果数量
    const [results, setResults] = useState(null); // 结果
    const [imgUrl, setImgUrl] = useState(null); // 图片
    const [tipsInfo, setTipsInfo] = useState(null); // 账户状态提示信息
    const [isCameraAvailable, setIsCameraAvailable] = useState(''); // 摄像头错误
    // 扫描
    const { videoRef, start, stop, captureImg } = useScanner({ autoScan: false })
    
    // 在组件挂载时启动扫描，卸载时停止扫描
    useEffect(() => {
        checkCamera().then((res) => {
            if (res.available) {
                setIsCameraAvailable(true)
                start()
            } else {
                setIsCameraAvailable(false)
                 notification.error({
                    message: '错误',
                    description: res.error,
                })
            }
        })
        
        // 组件卸载时清理资源
        return () => {
            stop()
        }
    }, [])
    const last_base64 = useRef('')
    const [isLoading, setIsLoading] = useState(false)
    const onMessageReceived = useCallback(async (result) => {
        const data = result.find((item) => item.includes('plugin'));
        if (!data) {
            return;
        }
        const slice = data.split('//');
        const type = slice[1]
        console.log(type, 'type')
        if (type !== 'fruits' && type !== 'all') return
        console.log('slice', slice)
        console.log(`命令：${slice[2]}, uid：${slice[3]}`)
        const uid = slice[3];
        if (slice.includes('is_connect_ailab')) {
            sendMessage({ [uid]: `${uid}_success` })
        }
        
        // 设置浮窗部分
        const setMsg = (response_template, msg) => {
            let type = response_template.type
            let message = msg
            let description = response_template.message
            const typeArray = ['success', 'info', 'warning', 'error']
            if (type && !typeArray.includes(type.toLowerCase())) {
                type = 'info'
            }
            notification[type]({
                message,
                description
            })
        }
        // 设置提示文案部分
        const setTips = (response_template) => {
            const { can_use, any_minutes, any_minutes_limit, remain_nums, next_use_time } = response_template
            setTipsInfo({
                can_use,
                tips: `当前账户每 ${any_minutes} 分钟可实验 ${any_minutes_limit} 次。今日总共还可实验 ${remain_nums} 次。`,
                next_use: `下一次扫描需等到 ${next_use_time}`
            })
        }
        // 指令
        const command = slice[2];
        console.log(command, 'command')
        // 扫描
        if (command === 'video_scanning') {
            console.log('扫描')
            const base64 = await captureImg()
            if (base64 === last_base64.current) return
            last_base64.current = base64
            setImgUrl(base64)
            const params = {
                image: base64,
                top_num: maxNum,
                extension_id: 'fruits',
                platform: 'lab'
            }
            console.log(params, 'params')
            setIsLoading(true)
            try {
                const res = await vegetableDetect(params)
                setMsg(res.response_template, res.message)
                setTips(res.response_template)
                // 设置结果参数
                setResults(res.data.result)
                const data = res.data.result.map(item => item.name).join('；')
                sendMessage({ [uid]: {
                    data,
                    nums: res.data?.result?.length
                } })
            } catch(error) {
                console.log(error, '哪里错了')
                if (error.data) {
                    const { message: msg, response_template } = error.data
                    setMsg(response_template, msg)
                    setTips(response_template)
                }
                sendMessage({ [uid]: `${uid}_error` })
            } finally {
                setIsLoading(false)
            }
        // 设置最大识别数
        } else if (command === 'set_max_num') {
            console.log('设置最大识别数')
            const num = slice[4]
            console.log(num, 'num')
            setMaxNum(num)
            sendMessage({ [uid]: `${uid}_success` });
        // 清除结果
        } else if (command === 'clearresults') {
            sendMessage({ [uid]: `${uid}_success` });
            setTipsInfo(null)
            setImgUrl(null)
            setResults(null)
            last_base64.current = ''
        }
       
    }, [sendMessage, captureImg, maxNum])

    // 在组件加载时检查蓝牙连接状态并设置监听
    useEffect(() => {
        setupNotifications(onMessageReceived)
        return () => {
            clearInterval(timer.current);
            stopNotifications(onMessageReceived)
        };
    }, [bluetooth, setupNotifications, stopNotifications, onMessageReceived]);

    // 收缩展开
    const { isOpen, setIsOpen, height, ref } = useCollapse()
    return (
        <div className='fruits plug-in'>
            <div className='plug-in-name'>果蔬识别</div>
            <div className='plug-in-content'>
                <div className='desc-content'>
                    <div className='desc-content describe'>
                        <div className='fruits__principle'>
                            果蔬识别的原理
                        </div>
                        <div className='fruits__desc'>
                            当需要识别果蔬时，系统需要先拍下一张照片。但照片可能光线不均、背景杂乱、或是果蔬只占画面的一部分，为了提升后续识别的效率，系统会先做预处理：例如调整亮度、对比度、去除噪点，并利用目标检测或分割算法把果蔬区域从背景中「剪」出来——这一步往往可以在算力并不是很高的设备本地瞬间完成，但对于后续的识别有非常重要的意义。
                        </div>
                        <div className="fruits__desc">
                            接下来，系统会针对处理后果蔬图像提取可量化的特征，这通常包括颜色分布（如典型的色调与饱和度）、形状（长与宽、圆或扁、轮廓形态等）以及表面纹理（纹理的疏密、方向等）。 最后，这些特征会送入一个经过训练的模型中，这个模型可能是传统的机器学习分类器，也可能是卷积神经网络（CNN）等深度学习方法。模型会根据学到的模式，判断它是什么品种，并输出结果。运行这样的模型对于算力要求比较高，并且模型也需要与时俱进，所以往往是在云服务器中运行。
                        </div>
                        <div className="fruits__desc">
                            <span className="fruits__desc--tips" onClick={() => setIsOpen(!isOpen)}>影响识别结果准确率的因素有哪些？<span className="fruits__link">{isOpen ? '点击折叠起来' : '点击看答案'}</span></span>
                            <ol className="fruits__list fruits__collapse" style={{maxHeight: height}} ref={ref}>
                                <li className='fruits__bold'>图像采集阶段<br/></li>
                                <span><span className='fruits__label'>光照条件：</span>过暗或过亮都会导致颜色失真，阴影、反光也可能掩盖果蔬表面的一些特征。</span><br/>
                                <span><span className='fruits__label'>拍摄角度与距离：</span>大角度倾斜或果蔬占画面比例太小，会让形状和纹理特征变形或模糊。</span><br/>
                                <span><span className='fruits__label'>分辨率：</span>低分辨率可能导致细节丢失（就像一张照片裁剪其中一个部分放大后就会显得模糊），所以往往需要使用手机或专业摄像设备才能获得足够清晰的图像（一般电脑摄像头是远不如手机清晰的）。</span>
                                <li className='fruits__bold'>预处理阶段<br/></li>
                                <span><span className='fruits__label'>背景复杂度：</span>背景太过杂乱，或是多种果蔬堆在一起，可能会让不那么聪明的分割算法不小心把部分果蔬也当成了没有意义的背景，直接就「剪」下来丢弃了。只看一个果蔬的一部分，识别的准确率自然就大大降低了。</span><br/>
                                <span><span className='fruits__label'>图像增强策略：</span>一幅画面如果本身有着斑驳地明暗或清晰度，在调整亮度、对比度、去噪等的过程中就会对一些算法造成困扰（例如不知道是该调亮还是调暗）。错误地图像增强，可能反而会破坏所需的果蔬特征（例如如果目标果蔬过亮了，可能就会变成一块白斑，识别的准确率自然就大大降低了）。</span>
                                <li className='fruits__bold'>特征提取阶段<br/></li>
                                <span>算法是否全面地考虑了影响果蔬品种的各种因素，例如颜色、轮廓等。</span>
                                <li className='fruits__bold'>模型与训练阶段<br/></li>
                                <span><span className='fruits__label'>训练数据的多样性与质量：</span>样本是否覆盖不同品种、成熟度、拍摄条件。数据越全，识别准确率就更高。</span><br/>
                                <span><span className='fruits__label'>样本平衡性：</span>某些品种数据太少就容易被模型忽略（例如模型见过的都是又粗又长又黄的香蕉，忽然给它看一根又短又细又绿的香蕉它可能就认不出来了）。</span><br/>
                                <span><span className='fruits__label'>模型结构与超参数：</span>模型的容量、卷积层设计、学习率等都会影响最终精度。这就涉及到深度学习领域很专业的知识了，需要 AI 科学家来不断调优。</span>
                            </ol>
                        </div>
                    </div>
                    <div className="fruits__block">
                        <div className="fruits__platform">
                            本扩展可在互联创作平台使用，或连接主控硬件后结合硬件编程平台使用。
                        </div>
                        <div className="fruits__flex">
                            <div className="fruits__video">
                                <span className="fruits__title">当前参数与摄像头画面</span>
                                {isCameraAvailable ? 
                                    <div className='desc'>
                                        <video ref={videoRef} muted loop playsInline autoPlay></video>
                                    </div> : <>
                                    <div className='desc'>
                                        <img src={notCamera} alt="" />
                                        <div>没有找到摄像头</div>
                                    </div>
                                    <div className='tip'>
                                        <div className='icon'><InfoCircleFilled /></div>
                                        请允许浏览器调用摄像头（camera）
                                    </div>
                                </>}
                            </div>
                            <div className="fruits__video">
                                <span className="fruits__title">最近一次扫描的画面与结果</span>
                                <div className='desc'>
                                    {imgUrl ? 
                                        <img className='fruits__capture' src={imgUrl} alt="" /> : 
                                        <>
                                            <img src={notScan} alt="" />
                                            <div>暂未进行过扫描</div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='fruits__results'>
                            <div className='fruits__panel fruits__result'>
                                    <div className='fruits__max'>
                                        最大结果数量：{maxNum}
                                    </div>
                                    {
                                    tipsInfo !== null && 
                                        <>
                                            <div className="fruits__tips">
                                                {tipsInfo?.tips}
                                            </div>
                                            {tipsInfo.can_use === false && <div className='fruits__tips fruits__tips--error'>{tipsInfo?.next_use}</div>}
                                        </>
                                    }
                            </div>
                            {isLoading ?
                                <div className='fruits__result'>...</div> :
                                // <div className='fruits__result'>
                                //     {results && results.length > 0 ? results.map((item, index) => {
                                //         return <div className='fruits__item' key={index}>
                                //             <div>{index + 1}、名称：{item.name}</div>
                                //             <div className='fruits__posibility'>可能性：{item.score}</div>
                                //         </div>
                                //     }) : ''}
                                // </div>
                                <div className='fruits__scan-data'>
                                    <div className='fruits__scan-title'>显示结果</div>
                                    <div className='fruits__scan-content'>
                                           {/* {
                                           results && results.length > 0 ? results.map((item, index) => {
                                                return <div className='fruits__item' key={index}>
                                                    <div>{index + 1}、名称：{item.name}</div>
                                                    <div className='fruits__posibility'>可能性：{item.score}</div>
                                                </div>
                                            }) : ''
                                            } */}
                                        {results && results.length > 0 ? results.map((item, index) => {
                                            return <div key={index} className='fruits__scan-row'>
                                                <span className='fruits__name'>{item.name}</span>
                                                <span className='fruits__percentage'
                                                    style={{
                                                        width: '100%',
                                                        background: '#F0F0F0',
                                                        backgroundImage: 'linear-gradient(to right, #0084FF, #0084FF)',
                                                        backgroundSize: `${item.score * 100}% 100%`,
                                                        backgroundRepeat: 'no-repeat',
                                                        borderRadius: '4px'}}
                                                ></span>
                                                <span className='fruits__score'>可能性：{(item.score * 100).toFixed(0)}%</span>
                                            </div>
                                        }): <Empty description="暂无数据" image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Fruits;